import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Assets
import logo from "../assets/img/logo.png";
import refImg from "../assets/img/ref.png";
import cpaImg from "../assets/img/cpa.png";
import swiperImg1 from "../assets/img/swiperimg1.svg";
import swiperImg2 from "../assets/img/swiperimg2.svg";
import icon1 from "../assets/img/icon1.svg";
import icon2 from "../assets/img/icon2.svg";
import icon3 from "../assets/img/icon3.svg"
import { getCountryCodes, saveBookDemo } from "../api/demo";

const Demo = () => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        firmName: "",
        firmSize: "",
        email: "",
        firstName: "",
        lastName: "",
        locale: "United States",
        source: "",
        phone: ""
    });
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await getCountryCodes();
                let list = response.data;
                if (list && !Array.isArray(list) && list.data && Array.isArray(list.data)) {
                    list = list.data;
                }

                setCountries(Array.isArray(list) ? list : []);
            } catch (error) {
                console.error("Failed to load countries", error);
            }
        };
        fetchCountries();
    }, []);

    const [errors, setErrors] = useState({});

    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const validatePhone = (phone) => {
        const cleaned = phone.replace(/\D/g, '');
        // Check for India, USA, Canada patterns
        // 10 digits (Standard local)
        // 11 digits starting with 1 (US/Canada with country code)
        // 12 digits starting with 91 (India with country code)
        return /^(1\d{10}|91\d{10}|\d{10})$/.test(cleaned);
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        let newErrors = { ...errors };

        if (name === "email") {
            if (!value) {
                newErrors.email = "Email is required";
            } else if (!validateEmail(value)) {
                newErrors.email = "Invalid email format";
            } else {
                delete newErrors.email;
            }
        }

        if (name === "phone") {
            if (!value) {
                newErrors.phone = "Phone number is required";
            } else if (!validatePhone(value)) {
                newErrors.phone = "Invalid format. Use 10 digits or +1/+91 country codes.";
            } else {
                delete newErrors.phone;
            }
        }
        setErrors(newErrors);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (errors[name]) {
            setErrors(prev => {
                const newErrs = { ...prev };
                delete newErrs[name];
                return newErrs;
            });
        }
    };

    const isStep1Valid = formData.firstName && formData.lastName && formData.firmName && formData.firmSize;
    const isStep2Valid = formData.phone && validatePhone(formData.phone) && formData.source && formData.locale && formData.email && validateEmail(formData.email);

    const handleNext = async () => {
        if (step === 1 && isStep1Valid) {
            setStep(2);
        } else if (step === 2 && isStep2Valid) {
            try {
                const payload = {
                    firm_name: formData.firmName,
                    firm_size: formData.firmSize,
                    business_email: formData.email,
                    first_name: formData.firstName,
                    last_name: formData.lastName,
                    location: formData.locale,
                    reference: formData.source,
                    phone_no: formData.phone,
                    date: new Date().toISOString().split('T')[0],
                    day: new Date().toLocaleDateString('en-US', { weekday: 'long' }),
                    time: new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' })
                };

                await saveBookDemo(payload);
                setStep(3);
                window.open("https://calendly.com/tech-trackmydoc/trackmydoc", "_blank");
            } catch (error) {
                console.error("Error submitting form:", error);

                setStep(3);
                window.open("https://calendly.com/tech-trackmydoc/trackmydoc", "_blank");
            }
        }
    };

    const inputClass = "w-full h-12 xl:h-14 px-4 border-2 border-[#bcd3ff] rounded-[10px] focus:ring-2 focus:ring-[#d9e6ff] focus:border-blue-500 outline-none transition placeholder:text-[#000724] text-gray-700";
    const selectClass = "w-full h-12 xl:h-14 px-3 pr-10 border-2 border-[#bcd3ff] rounded-[10px] focus:ring-2 focus:ring-[#d9e6ff] focus:border-blue-500 outline-none transition bg-white text-gray-700 appearance-none";

    return (
        <div className="flex flex-col lg:flex-row min-h-screen">
            <div className="lg:w-1/2 bg-[#1e4387] text-white px-6 md:px-0 md:pl-8 2xl:pl-12 flex flex-col justify-between relative overflow-hidden">
                <div className="mb-8">
                    <div className="flex items-center gap-2 pt-12 xl:pl-20">
                        <img src={logo} alt="Logo" className="sm:h-12 h-10" />
                    </div>
                </div>

                <div className="flex-grow justify-center text-center z-10 max-w-full lg:w-[400px] xl:w-[544px] mx-auto lg:mb-10 md:mb-16 mb-8 pt-4 2xl:pt-10">
                    <div className="relative  mx-auto mb-8">
                        <img src={refImg} alt="Mobile App Interface" className="w-full md:w-[300px] lg:w-[390px] 2xl:w-[640px] 2xl:h-[420px] object-contain drop-shadow-2xl mx-auto" />
                    </div>
                    <div className="xl:mb-10 mb-8">
                        <h2 className="text-xl md:text-[26px] xl:text-[32px] font-bold  max-w-lg text-white mx-auto leading-snug md:leading-[34px] xl:leading-[42px]">
                            Trusted by <span className="text-yellow-400">30,000+</span> tax, bookkeeping and accounting professionals
                        </h2>
                        <p className="text-white/80 text-sm md:text-base max-w-lg mx-auto leading-relaxed">
                            Built for modern tax and accounting firms to save time and work smarter.
                        </p>
                    </div>
                </div>
            </div>

            {/* Right Section - White Form */}
            <div className="lg:w-1/2 bg-white md:px-0 px-6 md:pr-8 lg:px-10 2xl:pr-32 flex flex-col justify-center  overflow-y-auto">
                <div className="max-w-full md:w-[500px] xl:w-[544px] mx-auto lg:mb-0 md:my-16 my-8">
                    <div className="flex items-center justify-center mb-6 flex-wrap gap-3">
                        <div className="flex text-yellow-500">
                            {[1].map(i => (
                                <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 24 24"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" /></svg>
                            ))}
                        </div>
                        <span className="text-[#50505e] font-medium text-base">4.7/5 across 7,600+ reviews</span>
                    </div>

                    <h1 className="text-2xl md:text-[32px] 2xl:text-[42px] font-semibold text-center text-[#000724] mb-2 xl:mb-4 leading-snug md:leading-[34px] xl:leading-[45px]">
                        Book a demo – see <br /> TrackMyDoc in action
                    </h1>
                    <p className="text-center text-[#50505e] sm:mb-4 xl:mb-10 text-base md:text-lg">
                        Learn how TrackMyDoc can help you uplevel the way you manage your practice.
                    </p>

                    {/* Form */}
                    <form className="space-y-4">
                        {step === 1 && (
                            <>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                    <div>
                                        <input
                                            type="text"
                                            name="firstName"
                                            value={formData.firstName}
                                            onChange={handleInputChange}
                                            placeholder="First name *"
                                            className={inputClass}
                                        />
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            name="lastName"
                                            value={formData.lastName}
                                            onChange={handleInputChange}
                                            placeholder="Last name *"
                                            className={inputClass}
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                    <div>
                                        <input
                                            type="text"
                                            name="firmName"
                                            value={formData.firmName}
                                            onChange={handleInputChange}
                                            placeholder="Firm name *"
                                            className={inputClass}
                                        />
                                    </div>

                                    <div className="relative">
                                        <select
                                            name="firmSize"
                                            value={formData.firmSize}
                                            onChange={handleInputChange}
                                            className={selectClass}
                                        >
                                            <option value="" disabled>
                                                Firm size *
                                            </option>
                                            <option value="1">1</option>
                                            <option value="2-5">2-4</option>
                                            <option value="5-9">5-9</option>
                                            <option value="10-14">10-14</option>
                                            <option value="25-49">25-49</option>
                                            <option value="50+">50+</option>
                                        </select>
                                        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                                            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>


                            </>
                        )}

                        {step === 2 && (
                            <>
                                {/* Business Email */}
                                <div>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        onBlur={handleBlur}
                                        placeholder="Business email *"
                                        className={`${inputClass} ${errors.email ? "!border-red-500" : ""}`}
                                    />
                                    {errors.email && (
                                        <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                                    )}
                                </div>

                                {/* Phone Number */}
                                <div>
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                        onBlur={handleBlur}
                                        placeholder="Phone number (10 digits)"
                                        className={`${inputClass} ${errors.phone ? "!border-red-500" : ""}`}
                                    />
                                    {errors.phone && (
                                        <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
                                    )}
                                </div>

                                {/* Select Country */}
                                <div className="relative">
                                    <select
                                        name="locale"
                                        value={formData.locale}
                                        onChange={handleInputChange}
                                        className={selectClass}
                                    >
                                        <option value="" disabled>Select country *</option>
                                        {countries.length > 0 ? (
                                            countries.map((country, idx) => {
                                                const countryName =
                                                    country.name || country.country_name || country;
                                                return (
                                                    <option key={idx} value={countryName}>
                                                        {countryName}
                                                    </option>
                                                );
                                            })
                                        ) : (
                                            <>
                                                <option value="United States">United States</option>
                                                <option value="Canada">Canada</option>
                                                <option value="India">India</option>
                                                <option value="United Kingdom">United Kingdom</option>
                                                <option value="Australia">Australia</option>
                                            </>
                                        )}
                                    </select>

                                    <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                                        <svg
                                            className="w-4 h-4 text-gray-500"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M19 9l-7 7-7-7"
                                            />
                                        </svg>
                                    </div>
                                </div>

                                {/* Source Selection */}
                                <div className="relative">
                                    <select
                                        name="source"
                                        value={formData.source}
                                        onChange={handleInputChange}
                                        className={selectClass}
                                    >
                                        <option value="" disabled>
                                            How did you hear about TrackMyDoc?
                                        </option>
                                        <option value="Google Search">Google Search</option>
                                        <option value="Instagram">Instagram</option>
                                        <option value="LinkedIn">LinkedIn</option>
                                        <option value="Facebook">Facebook</option>
                                        <option value="Twitter">Twitter</option>
                                        <option value="Referral">Referral</option>
                                    </select>

                                    <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                                        <svg
                                            className="w-4 h-4 text-gray-500"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M19 9l-7 7-7-7"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </>
                        )}


                        {step === 3 && (
                            <div className="text-center py-4 sm:py-10">
                                <div className="sm:w-20 sm:h-20 w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                                    <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>
                                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 sm:mb-4 mb-2">Submission Successful!</h2>
                                <p className="text-gray-600 sm:mb-6 mb-0 text-sm sm:text-base">
                                    Thank you for booking a demo. Our team will connect with you shortly.
                                    Please check the new tab to book your slot.
                                </p>
                            </div>
                        )}

                        {/* Progress Bar */}
                        <div className="">
                            <div className="flex justify-between text-base text-gray-900 mb-2">
                                <span>{step}/3</span>
                            </div>

                            <div className="w-full bg-[#EAF2FF] rounded-full h-1.5">
                                <div
                                    className="bg-[#bcd3ff] h-1.5 rounded-full transition-all duration-300 font-semibold"
                                    style={{ width: `${(step / 3) * 100}%` }}
                                ></div>
                            </div>
                        </div>

                        {step !== 3 && (
                            <div className="pt-3">
                                {/* Button */}
                                <button
                                    type="button"
                                    onClick={handleNext}
                                    disabled={(step === 1 && !isStep1Valid) || (step === 2 && !isStep2Valid)}
                                    className={`w-full font-bold h-12 xl:h-14 rounded-lg transition duration-300 flex items-center justify-center gap-2 md:text-lg text-base
                                        ${((step === 1 && isStep1Valid) || (step === 2 && isStep2Valid))
                                            ? "bg-blue-600 hover:bg-blue-700 text-white"
                                            : "bg-[#f5f8ff] text-[#a2a2af] cursor-not-allowed"}`}
                                >
                                    {step === 2 ? "Book a Demo" : "Next"}
                                    <span className="text-xl">→</span>
                                </button>
                            </div>
                        )}

                        {/* Terms */}
                        {step !== 3 && (
                            <p className="text-xs text-center text-[#767689] mt-6">
                                By proceeding, you agree to TrackMyDoc's{" "}
                                <a href="#" className="underline text-[#767689]">
                                    terms of service
                                </a>{" "}
                                and{" "}
                                <a href="#" className="underline text-[#767689]">
                                    privacy policy
                                </a>
                                .
                            </p>
                        )}
                    </form>


                </div>
            </div>
        </div>
    );
};

export default Demo;